import React from 'react';
import { Input } from 'antd';
import { GroupProps as GroupCopyProps } from 'antd/lib/input/Group';

export type GroupProps = GroupCopyProps;

const ProInputGroup: React.FC<GroupProps> = props => {
  const { children, ...resProps } = props;
  return <Input.Group {...resProps}>{children}</Input.Group>;
};

export default ProInputGroup;
